import React, { useState, useEffect } from 'react';

const AvanceEstadosBotones = (p) => {
    const data = p.data ?? {};
    const completo = data.completo;
    const listo_para_inventario = data.listo_para_inventario;
    const inventario_campo_id = data.inventario_campo_id;
    const id = data.id;
    const planesActivos = data && data.planes && data.planes.length;

    return (
        <div className='w-100 h-100 m-0 p-0 contenedor'>
            {![null, undefined].includes(inventario_campo_id) && <div className='w-100 text-center text-s text-bold'>Inventariado</div>}

            {!inventario_campo_id && (listo_para_inventario === 0 || completo !== 1) &&
                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    {data.origen === "vivero" && <div className={'w-35 round-m text-xs text-center text-center shadow-sm border m-0 p-1 nowrap' + (completo === 1 ? ' bg-purple4 text-white ' : "border-dark")}>LISTO</div>}
                    {data.origen === "directo" && <div className={'w-35 round-m text-xs text-center text-center shadow-sm border m-0 p-1 nowrap bg-blue2 text-white'}>DIRECTO</div>}
                    <div className={'w-60 round-m text-xs text-center text-center shadow-sm border m-0 p-1 nowrap' +
                        (planesActivos ? ' bg-green4 text-light scale-025 pointer' : "border-dark")}
                        onClick={() => { if (planesActivos) p.detalles() }}
                    >PLAN {planesActivos && <span className='text-xxs text-bold ms-2'>{data.planes.length}</span>}
                    </div>
                </div>}
        </div>


    )
}

export default AvanceEstadosBotones;